import React from 'react';
import { useI18n } from '../../../i18n/I18nContext';
import { hasToken, splitTemplate } from '../reminderUi';
import './Composer.css';

/**
 * The message as a student would read it: the placeholders are filled with example values and
 * shown in a soft highlight, so the staff sees where the name, the course and the link land.
 *
 *   <MessagePreview template={text} values={{ name: 'Dilnoza', course: 'Rus tili A1', link: 'https://...' }} promoCode="SALE10" />
 *
 * A placeholder with no value stays as written ("{code}" while no promo code is chosen). With a
 * promo code and no {code} in the text, the server appends " Promokod: CODE" (spec section 3), and
 * so does this preview — that word is part of the student's message, so it is not translated.
 */
export default function MessagePreview({ template, values = {}, promoCode, className = '' }) {
  const { t } = useI18n();
  const text = String(template || '');

  if (!text.trim()) {
    return <p className={`rmc-bubble is-empty ${className}`.trim()}>{t('reminders.message.previewEmpty')}</p>;
  }

  const parts = splitTemplate(text);
  const appendCode = promoCode && !hasToken(text, 'code');
  return (
    <p className={`rmc-bubble ${className}`.trim()}>
      <span className="visually-hidden">{`${t('reminders.message.preview')}: `}</span>
      {parts.map((part, index) => (
        part.token ? (
          <span key={index} className="rmc-bubble__token">{values[part.token] || `{${part.token}}`}</span>
        ) : (
          <React.Fragment key={index}>{part.text}</React.Fragment>
        )
      ))}
      {appendCode ? ` Promokod: ${promoCode}` : null}
    </p>
  );
}
